import { render } from "./OptionCard.vue?vue&type=template&id=47f8d75b"
import script from "./OptionCard.vue?vue&type=script&lang=js"
export * from "./OptionCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__